import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface AustralianLocationSelectorProps {
  state: string;
  city: string;
  onStateChange: (value: string) => void;
  onCityChange: (value: string) => void;
}

export function AustralianLocationSelector({
  state,
  city,
  onStateChange,
  onCityChange,
}: AustralianLocationSelectorProps) {
  // State is always VIC for Melbourne area
  React.useEffect(() => {
    if (state !== "VIC") {
      onStateChange("VIC");
    }
  }, [state, onStateChange]);

  return (
    <div className="grid grid-cols-2 gap-4">
      {/* Suburb */}
      <div className="space-y-2">
        <Label htmlFor="city">Suburb *</Label>
        <Input
          id="city"
          value={city}
          onChange={(e) => onCityChange(e.target.value)}
          placeholder="Enter suburb"
          required={true}
          className="h-11"
        />
      </div>

      {/* State - Always VIC */}
      <div className="space-y-2">
        <Label htmlFor="state">State/Region</Label>
        <Input id="state" value="VIC" disabled={true} className="h-11 bg-muted" />
      </div>
    </div>
  );
}
